import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 19v-10.5a3.5 3.5 0 1 1 7 0v10.5","key":"svg-0"}],["path",{"d":"M4 13h7","key":"svg-1"}],["path",{"d":"M21 12h-6","key":"svg-2"}]]

/**
 * IconTextDecrease
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItdGV4dC1kZWNyZWFzZSIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNNCAxOXYtMTAuNWEzLjUgMy41IDAgMSAxIDcgMHYxMC41IiAvPgogIDxwYXRoIGQ9Ik00IDEzaDciIC8+CiAgPHBhdGggZD0iTTIxIDEyaC02IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/text-decrease
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconTextDecrease = createReactComponent('outline', 'text-decrease', 'TextDecrease', __iconNode);

export default IconTextDecrease;